import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CommonStatCard from "../../../pt/pt-flow-new/CommonStatCard";
import { getCardIcon } from "../../../common-data/Conversions";
import CalendarLoader from "../../../common-components/CalendarLoader";

const StaffAttendanceStats = () => {
  const {
    staffAttendanceStats,
    staffAttendanceStatsLoading,
    staffAttendanceStatsError,
  } = useSelector((state) => state.prospects);

  const [statsData, setStatsData] = useState(null);

  const EXCLUDED_KEYS = [
    "total_morning_checkin",
    "total_evening_checkin",
    "total_morning_checkout",
    "total_evening_checkout",
    "total_trainer",
    "total_receptionist",
    "total_staff",
  ];

  const SORT_ORDER = [
    "total_checkin",
    "total_trainer_checkin",
    "total_receptionist_checkin",
    "total_late_checkin",
    "total_on_time_checkin",
    "total_checkout",
    "total_absent",
  ];

  useEffect(() => {
    if (
      !staffAttendanceStatsLoading &&
      !staffAttendanceStatsError &&
      staffAttendanceStats?.status
    ) {
      setStatsData(staffAttendanceStats?.data);
    } else {
      setStatsData(null);
    }
  }, [
    staffAttendanceStatsLoading,
    staffAttendanceStatsError,
    staffAttendanceStats,
  ]);

  return (
    <>
      <div className="cards-container cards-grid-container staff-attendance-report-stats grid-5">
        {staffAttendanceStatsLoading ? (
          <CalendarLoader daysCount={5} shiftsPerDay={2} />
        ) : statsData ? (
          Object.entries(statsData)
            .sort(([keyA], [keyB]) => {
              const indexA = SORT_ORDER.indexOf(keyA);
              const indexB = SORT_ORDER.indexOf(keyB);

              if (indexA === -1) return 1;
              if (indexB === -1) return -1;
              return indexA - indexB;
            })
            .map(([key, value], index) => (
              <React.Fragment key={index}>
                {!EXCLUDED_KEYS.includes(key) && (
                  <CommonStatCard
                    tagName="lms"
                    cardLabel={key?.replace(/_/g, " ")}
                    value={
                      key === "total_trainer_checkin"
                        ? `${value || 0} / ${statsData?.total_trainer || 0}`
                        : key === "total_receptionist_checkin"
                        ? `${value || 0} / ${
                            statsData?.total_receptionist || 0
                          }`
                        : key === "total_checkin"
                        ? `${value || 0} / ${statsData?.total_staff || 0}`
                        : value || 0
                    }
                    icon={getCardIcon(key)}
                  />
                )}
              </React.Fragment>
            ))
        ) : null}
      </div>
    </>
  );
};

export default StaffAttendanceStats;
